define('drops/buttonWithIcon/buttonWithIcon',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/tooltip',
    'lq/onlongpress'
], function ($, Drop, Style, util, Tooltip, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            icon: '?',
            text: 'New Button with Icon',
            iconAlignment: 'left',
            title: {
                option: Tooltip.hardcoded
            },
            useDynamicWidth: true,
            useDynamicHeight: true,
            longPressDelay: 1000,
            activeStyleDuration: 0
        }
    };

    function ButtonWithIcon(options) {
        var self = this;

        Drop.call(this, $('<div/>'), defaults, options);

        this.defaultStyleSettings = {
            text: { verticalAlign: 'middle' }
        };

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$icon = $('<span class="buttonIcon drop-text-content">' + this.data.icon + '</span>');

        this.$text = $('<span class="text drop-text-content">' + this.data.text + '</span>');

        this.$button = $('<div/>')
            .addClass('boxToBorderSize drop-text-content')
            .attr('name', this.data.name)
            .append((this.data.iconAlignment === 'left' || this.data.iconAlignment === 'top') ? this.$icon : this.$text)
            .append((this.data.iconAlignment === 'left' || this.data.iconAlignment === 'top') ? this.$text : this.$icon)
            .addClass((this.data.iconAlignment === 'top' || this.data.iconAlignment === 'bottom') ? 'flex-column' : 'flex-row')
            .attr('tabindex', this.data.tabIndex)
            .css({
                display: 'flex',
                flex: '1 1 100%',
                width: '100%'
            });

        // WHY setting 'display: table' on $element would break centered anchoring, so we have to add a wrapper
        this.$element
            .append($('<div />')
                .css({
                    cursor: 'pointer',
                    display: 'flex',
                    whiteSpace: 'pre-wrap',
                    height: '100%',
                    width: '100%'
                })
                .append(this.$button));

        new OnLongPress().applyLongPressOnElement(this.$button, this);
        if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            var self = this;
            this.$element
                .on('keypress', function (e) {
                    if (e.keyCode === 13) {
                        self.triggerEvent(self.data.eventing.clicked.raisedEventName);
                    }
	            });
        }

        if (this.data.activeStyleDuration > 0) {
            this.$element
                .on('click', this.triggerActiveStyle.bind(this));
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');
        this.applyEventTrigger('mouseLeave', 'mouseleave');

        this.tooltip = new Tooltip(this, this.data.title, this.$element);
    };

    Drop.extend(ButtonWithIcon);

    ButtonWithIcon.typeName = 'ButtonWithIcon';

    ButtonWithIcon.prototype.triggerActiveStyle = function () {
        this.$button.addClass('active');

        var self = this;
        setTimeout(function () {
            self.$button.removeClass('active');
        }, this.data.activeStyleDuration);
    };

    ButtonWithIcon.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$button);
        if (typeof this.data.styles === 'object' && this.data.styles.buttonIcon)
            Style.renderStyles(this, null, this.$icon, this.data.styles, "buttonIcon");

        // WHY: the text-stylings of the main element should affect $text sub-element, but not $icon
        this.moveAttributeToTextElement('font-style', 'normal');
        this.moveAttributeToTextElement('text-decoration', 'none');
        this.moveAttributeToTextElement('text-transform', 'none');
    };

    ButtonWithIcon.prototype.preRender = function () {
        this.tooltip.update();

        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    ButtonWithIcon.prototype.postRender = function () {
        this.renderStyles();
    };

    ButtonWithIcon.prototype.moveAttributeToTextElement = function (attributeName, parentReplacement) {
        this.$text.css(attributeName, this.$button.css(attributeName));
        this.$button.css(attributeName, parentReplacement);
    };

    return ButtonWithIcon;
});
